import(/* webpackMode: "eager", webpackExports: ["DashboardLayout"] */ "/opt/buildhome/repo/apps/personal-web/components/dashboard-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EducationContent"] */ "/opt/buildhome/repo/apps/personal-web/components/education-content.tsx");
